<template>
  <div id="event-dates">
    <h1 v-if="eventItem" class="text-center mb-3">
      <router-link :to="'/events/'+ eventItem.id">
        <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
      </router-link>
    </h1>
    
    <div v-if="dateItem" class="container">
        <h2 class="text-center">Your presence at Fair Booth</h2>
        <h3 class="text-center" v-if="showConfirm">Please, check your dates of staying at the booth before continuing.</h3>

        <div class="container alert alert-info text-center my-4">
            <p>
                <i class="fa fa-info-circle me-2"></i> <strong>Pay attention!</strong><br>
                Changing dates does not involve the automatic change of hotel checkin/checkout!
            </p>
            <p><span class="font-bold">In case you need to change the check-in/check-out of your hotel, you must advise <span v-html="reference"></span></span>.</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-lg-auto">

                <div class="mb-3" v-if="input.startDate !== ''">
                    <label for="startDate" class="form-label">Date of arrival at the booth</label>
                    <Datepicker v-model="input.startDate" :format="format" timezone="Europe/Rome" :enableTimePicker="false" />
                </div>

                <div class="mb-3" v-if="input.endDate !== ''">
                    <label for="endDate" class="form-label">Date of departure from the booth</label>
                    <Datepicker v-model="input.endDate" :format="format" timezone="Europe/Rome" :enableTimePicker="false" />
                </div>

                <div class="text-center mb-3">
                    <input type="hidden" v-model="input.confirmed" />
                    <button type="button" class="btn btn-coesia me-2" @click="saveInfo">
                        Save info
                        <i class="fas fa-save"></i>
                    </button>
                    <button @click="goBack" class="btn btn-secondary">
                        Cancel
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'EventsDates',
  props: ['contactid', 'id'],
  setup() {
    const format = 'yyyy-MM-dd';
    return {
      format
    }
  },
  methods: {
    populateInputs(userItem) {
      this.input.startDate = userItem.checkinFair;
      this.input.endDate = userItem.checkoutFair;
        this.input.confirmed = userItem.confirmed;
    },
    saveInfo() {
      let contactItem = {
        fairId: Number(this.id),
        userId: Number(this.user.id),
        checkinFair: this.input.startDate,
          checkoutFair: this.input.endDate,
          confirmed: 1
      }
      //console.log(contactItem);
      // => funzione salvataggio info
      let save = this.$store.dispatch('saveDateInfo', contactItem)
			if (save)	this.$router.push('/events')
      /* this.$store.dispatch('saveDateInfo', contactItem).then(() => {
        this.$router.push('/events')
      }) */
    },
    goBack() {
      this.$store.dispatch('goBack');
    }
  },
  /* watch: {
      dateItem() {
        if (!this.dateItem.confirmed) {
          this.showConfirm = true
      }
    }
  }, */
  computed: {
    ...mapGetters([
      "contactItems",
      'user'
    ]),
    eventItem () {
      return this.$store.getters.fairItemFromId(this.id);
    },
    reference () {
        if (!this.eventItem) return null
        if (this.eventItem.hotel_ref_name) return this.eventItem.hotel_ref_name + " (<a href=\"mailto:" + this.eventItem.hotel_ref_email + "\">" + this.eventItem.hotel_ref_email + "</a>)"
        return "your travel management of reference"
    },
    dateItem() {
          if (!this.user) return null
      let userItem = this.$store.getters.contactItemFromId(this.user.id);
      if (!userItem) return null
      let participant
      if (userItem.participants) {
        participant = userItem.participants.find(userItem => userItem.fairId === Number(this.id))
      } else if (userItem.staff) {
        participant = userItem.staff.find(userItem => userItem.fairId === Number(this.id))
      }
        if (participant) {
            userItem.confirmed = participant.confirmed
            this.populateInputs(participant)
        }
      return userItem;
    },
  },
  data() {
    return {
      input: {
        startDate: "",
        endDate: "",
        confirmed: false
      },
      showConfirm: false,
    };
  },
  components: { Datepicker }
}
</script>

<style>
.dp__selection_preview {
  width: 35% !important;
}
.dp__action_buttons {
  width: 65% !important;
}
</style>

<style scoped>
</style>
